import { CALL_API, Schemas } from '../../common/middleware/api';

export const LOCALIZATIONS_REQUEST = 'LOCALIZATIONS_REQUEST';
export const LOCALIZATIONS_SUCCESS = 'LOCALIZATIONS_SUCCESS';
export const LOCALIZATIONS_FAILURE = 'LOCALIZATIONS_FAILURE';

export const LOCALIZATION_FETCH_REQUEST = 'LOCALIZATION_GET_REQUEST';
export const LOCALIZATION_FETCH_SUCCESS = 'LOCALIZATION_GET_SUCCESS';
export const LOCALIZATION_FETCH_FAILURE = 'LOCALIZATION_GET_FAILURE';

export const LOCALIZATION_UPDATE_REQUEST = 'LOCALIZATION_UPDATE_REQUEST';
export const LOCALIZATION_UPDATE_SUCCESS = 'LOCALIZATION_UPDATE_SUCCESS';
export const LOCALIZATION_UPDATE_FAILURE = 'LOCALIZATION_UPDATE_FAILURE';

export const LOCALIZATION_DELETE_REQUEST = 'LOCALIZATION_DELETE_REQUEST';
export const LOCALIZATION_DELETE_SUCCESS = 'LOCALIZATION_DELETE_SUCCESS';
export const LOCALIZATION_DELETE_FAILURE = 'LOCALIZATION_DELETE_FAILURE';

export const loadLocalizations = (options) => ({
	[CALL_API]: {
		types: [LOCALIZATIONS_REQUEST, LOCALIZATIONS_SUCCESS, LOCALIZATIONS_FAILURE],
		endpoint: `api/localizations`,
		request: options,
		schema: Schemas.LOCALIZATION_ARRAY
	}
});

export const fetchLocalization = (id) => ({
	[CALL_API]: {
		types: [LOCALIZATION_FETCH_REQUEST, LOCALIZATION_FETCH_SUCCESS, LOCALIZATION_FETCH_FAILURE],
		endpoint: `api/localizations/${id}`,
		schema: Schemas.LOCALIZATION
	}
});

export const updateLocalization = (localization, rootName, onSuccessEvent) => ({
	[CALL_API]: {
		types: [LOCALIZATION_UPDATE_REQUEST, LOCALIZATION_UPDATE_SUCCESS, LOCALIZATION_UPDATE_FAILURE],
		endpoint: `api/${rootName}/localization`,
		method: 'PUT',
		request: localization,
		schema: Schemas.LOCALIZATION,
		form: 'localization',
		onSuccessEvent
	}
});

export const deleteLocalization = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [LOCALIZATION_DELETE_REQUEST, LOCALIZATION_DELETE_SUCCESS, LOCALIZATION_DELETE_FAILURE],
		endpoint: `api/localizations/${id}`,
		method: 'DELETE',
		schema: Schemas.LOCALIZATION,
		onSuccessEvent,
		remove: true
	}
});